module.exports = "pegasus_template/assets/tech/medium/6.jpg";